/* src/app/modules/portal/components/user-documentation/user-documentation.component.css */
#cancelButton {
  float: right;
  justify-content: right;
}
#help_menu {
  display: flex;
  flex-direction: column;
}
.text-setting {
  text-align: center;
}
#popOver {
  width: fit-content;
  margin-top: 20px;
}
@media not all and (min-width: 768px) {
  #help_menu {
    flex-direction: row;
  }
  .text-setting {
    align-self: center;
    padding-left: 3%;
    text-align: inherit;
    font-size: initial;
  }
  #popOver {
    width: 100%;
  }
}
/*# sourceMappingURL=user-documentation.component.css.map */
